export default {
  canWrite(context) {
    const canWrite = context.data && context.data.accessRights && context.data.accessRights.write;
    return canWrite;
  },
  canRead(context) {
    const canRead = context.data && context.data.accessRights && context.data.accessRights.read;
    return canRead;
  }
};
